/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description No Content
 */
export const postApiResetpassword204Schema = z.any();

export const postApiResetpasswordMutationRequestSchema = z.object({
  token: z.coerce.string(),
  newPassword: z.coerce.string().min(8).max(200),
  newPasswordRepeat: z.coerce.string().min(8).max(200),
});

export const postApiResetpasswordMutationResponseSchema = z.lazy(
  () => postApiResetpassword204Schema,
);
